// Making a new JS component
// 1 - Replace heroBanner with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var heroBanner = {
	name: 'heroBanner',
	componentInitSelector: '.hero-banner',
	registerComponent: function() {
		if ( $(heroBanner.componentInitSelector).length ) {
			framework.registerComponent(heroBanner);
		}
	},
	initheroBanner: function() {
        // Put your args and inits here with their options.
        $(heroBanner.componentInitSelector).on('click touch', 'button', function() {
        	heroVideo = document.getElementById("heroVideo");

        	if ( $(this).hasClass('paused') ) {
        		heroVideo.play();
        		$(this).removeClass('paused');
        	} else {
        		heroVideo.pause();
        		$(this).addClass('paused');
        	}

        	$( window ).scroll(function() {
    			log('from top: ' + document.body.scrollTop );
        	})

        })
        // End
        // log(config.application.name + " •• heroBanner in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
	init: function() {
		// All code for this component goes in here

		// End
		heroBanner.initheroBanner();
	}
}

// Register self to the framework
heroBanner.registerComponent();